/**
 * Leveredges React 16 render return type change to allow a
 * dummy noop component that renders nothing to the real DOM.
 */
export default ({ children }) => children;



// WEBPACK FOOTER //
// ./src/components/Wrapper.tsx